import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4bb097b9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "color_install" }
const _hoisted_2 = { class: "color_install_pattern" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pattern_name" }, "频道配置：", -1))
const _hoisted_4 = { class: "pattern_common" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "color_install_pattern color_install_patterns" }
const _hoisted_7 = { class: "pattern_name" }
const _hoisted_8 = {
  key: 0,
  class: "preview"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_color_picker = _resolveComponent("el-color-picker")!
  const _component_lighvideo = _resolveComponent("lighvideo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colorList, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item,
            class: "pattern_common_color",
            style: _normalizeStyle({ background: item }),
            onClick: ($event: any) => (_ctx.getColor(item))
          }, null, 12, _hoisted_5))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.color), 1),
      _createVNode(_component_el_color_picker, {
        modelValue: _ctx.color,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.color) = $event)),
        predefine: _ctx.colorList,
        size: "mini"
      }, null, 8, ["modelValue", "predefine"])
    ]),
    _createElementVNode("div", {
      class: "color_install_preview",
      onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toPreview && _ctx.toPreview(...args)), ["stop"]))
    }, [
      _createTextVNode(" 预览 "),
      (_ctx.preview)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_lighvideo, {
              childclo: _ctx.color,
              title: _ctx.title
            }, null, 8, ["childclo", "title"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}